import axios from "axios";
import { apiUrl, BACKEND_UNREACHABLE_MESSAGE } from "./backendUrl";

export const api = axios.create({
  baseURL: apiUrl,
});

export const AUTH_SESSION_EXPIRED_EVENT = "fullbook:auth-session-expired";
export const AUTH_SESSION_EXPIRED_MESSAGE = "La sessione è scaduta. Accedi di nuovo.";

let authSessionExpiredDispatched = false;

export const resetAuthSessionExpiredGuard = () => {
  authSessionExpiredDispatched = false;
};

const isPublicOrAuthenticationRequest = (config) => {
  const requestUrl = String(config?.url || "");
  let requestPath;
  try {
    requestPath = new URL(requestUrl, window.location.origin).pathname;
  } catch (error) {
    requestPath = requestUrl.split("?")[0];
  }
  if (requestPath.startsWith("/api/")) {
    requestPath = requestPath.slice(4);
  }
  return [
    "/auth/login",
    "/auth/register",
    "/auth/forgot-password",
    "/auth/reset-password",
    "/public",
    "/notifications/confirm",
    "/reminders/confirm",
    "/reminders/cancel",
  ].some((path) => requestPath === path || requestPath.startsWith(`${path}/`));
};

const hasAuthenticationHeader = (config) => {
  const headers = config?.headers;
  return Boolean(
    headers?.Authorization ||
      headers?.authorization ||
      headers?.get?.("Authorization")
  );
};

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fullbook_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error?.response) {
      error.userMessage = BACKEND_UNREACHABLE_MESSAGE;
    }
    if (
      error?.response?.status === 401 &&
      hasAuthenticationHeader(error.config) &&
      !isPublicOrAuthenticationRequest(error.config)
    ) {
      localStorage.removeItem("fullbook_token");
      if (!authSessionExpiredDispatched) {
        authSessionExpiredDispatched = true;
        window.dispatchEvent(new CustomEvent(AUTH_SESSION_EXPIRED_EVENT));
      }
    }
    return Promise.reject(error);
  }
);

export { apiUrl };
